import React from "react";
import DotsComponent from "./DotsComponent";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
export default function CardRender(props) {
  return props.comp.map((val) => {
    return (
      <>
        <span className="card">
          <DotsComponent />
          <div className="card-up">
            <div className="card-up-data">
              <h1>{val.card1up1}</h1>
              <p>{val.card1up2}</p>
            </div>
            {val.gain?<div className="show-gain" id={val.gain < 0 ? "show-loss" : ""}>
              {val.gain < 0 ? (
                <TrendingDownOutlinedIcon
                  style={{ color: "#FF4451", fontSize:'small' }}
                  className="gain-icon"
                />
              ) : (
                <TrendingUpOutlinedIcon style={{fontSize:'small'}} className="gain-icon" />
              )}
              <span>{val.gain}%</span>
            </div>:""}
            <p>{val.card1up3}</p>
          </div>
          <p className="card-dn-p">{val.card1dnP}</p>
        </span>
      </>
    );
  });
}
